module.exports = __webpack_public_path__ + "f7b3cd539bd8161968de2268d8b3d66a.svg";